module.exports = __webpack_public_path__ + "img/user-engagement-female.73c6d397.png";